import { getLocaleData } from './localeUtils';

export const formatThematicZones = (count: number, locale?: string) => {
  const localeData = getLocaleData(locale);

  if (count % 10 === 1) {
    return `${count} ${localeData.thematicZone}`;
  } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count)) {
    return `${count} ${localeData.thematicZones}`;
  } else {
    return `${count} ${localeData.thematicZonesGenitive}`;
  }
};

export const formatCafesAndRestaurants = (count: number, locale?: string) => {
  const localeData = getLocaleData(locale);

  if (count === 1) {
    return `${count} ${localeData.restaurant}`;
  } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count)) {
    return `${count} ${localeData.cafesAndRestaurants}`;
  } else {
    return `${count} ${localeData.cafesAndRestaurantsGenitive}`;
  }
};

export const formatThematicStores = (count: number, locale?: string) => {
  const localeData = getLocaleData(locale);

  if (count === 1) {
    return `${count} ${localeData.themedShop}`;
  } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count)) {
    return `${count} ${localeData.themedShops}`;
  } else {
    return `${count} ${localeData.themedShopsGenitive}`;
  }
};
